import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { rankingMovies } from '@/mocks/movies';

export default function RankingList() {
  return (
    <section className="py-8 px-4 md:px-6 max-w-7xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            <i className="ri-fire-fill text-accent-500 mr-2"></i>
            影视排行榜
          </h2>
        </div>
        <span className="text-foreground-500 text-xs">实时更新 · 数据来源：全网综合评分</span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Ranking list */}
        <div className="bg-background-100 rounded-xl p-5 order-2 lg:order-1">
          <div className="space-y-1">
            {rankingMovies.map((movie, index) => (
              <MovieCard
                key={movie.id}
                item={movie}
                variant="ranking"
                rank={index + 1}
              />
            ))}
          </div>
        </div>

        {/* Featured ranking item */}
        <div className="order-1 lg:order-2">
          <Link to={`/article/${rankingMovies[0].id}`} className="block cursor-pointer group">
            <div className="relative overflow-hidden rounded-xl aspect-video mb-4">
              <img
                src={rankingMovies[0].image}
                alt={rankingMovies[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="px-3 py-1 bg-accent-500 text-background-950 text-xs font-bold rounded-full">
                  TOP 1 · 评分 {rankingMovies[0].rating}
                </span>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <h3 className="text-background-50 text-xl font-bold mb-2 font-heading">
                  {rankingMovies[0].title}
                </h3>
                <p className="text-background-50/70 text-sm line-clamp-2">
                  {rankingMovies[0].description}
                </p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  {rankingMovies[0].tags.map((tag) => (
                    <span key={tag} className="text-background-50/80 text-xs px-2 py-0.5 bg-background-50/10 rounded-full">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Link>

          {/* Top 2-3 */}
          <div className="grid grid-cols-2 gap-4">
            {rankingMovies.slice(1, 3).map((movie, index) => (
              <Link key={movie.id} to={`/article/${movie.id}`} className="block cursor-pointer group">
                <div className="relative overflow-hidden rounded-lg aspect-video mb-2">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-bold rounded-full">
                      TOP {index + 2}
                    </span>
                  </div>
                  <div className="absolute bottom-2 left-2 right-2">
                    <h4 className="text-background-50 text-sm font-semibold truncate">
                      {movie.title}
                    </h4>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}